module.exports = __webpack_public_path__ + "static/media/whychoose_0.d0429a52.jpg";